{
  "pad": {
    "label": "Customer’s signature",
    "canvas": "Signature area: sign with a finger, a pen or the mouse",
    "here": "Sign here",
    "clear": "Clear",
    "hint": "Optional: the customer’s typed name is enough. A signature drawn here is kept with the record as evidence.",
    "signed": "Signature captured"
  },
  "upload": {
    "failed": "The signature could not be saved. Attach a photo of the signed paper instead."
  },
  "sign": {
    "name": "Name",
    "signature": "Signature",
    "date": "Date",
    "customerSignature": "Customer’s signature"
  },
  "estimate": {
    "title": "Service estimate",
    "show": "Show estimate",
    "showHint": "Opens in a new tab, to show the customer or print it.",
    "back": "Back to the job",
    "agreement": "Price approval",
    "notAgreed": "Not yet agreed",
    "version": "v{{n}} · {{status}}",
    "date": "Date",
    "preparedFor": "Prepared for",
    "customerCode": "Customer code",
    "location": "Service location",
    "contact": "On-site contact",
    "problem": "Problem reported",
    "requested": "Service requested",
    "items": "Chargeable items",
    "noItems": "No chargeable items yet.",
    "covered": "Covered by the contract",
    "coveredRef": "Covered by contract {{reference}}",
    "coveredNote": "No charge: these items are covered by the service contract.",
    "quantity": "Quantity",
    "item": "Item",
    "acceptance": "Customer’s acceptance",
    "statement": "I accept the work and the prices in this estimate.",
    "acceptedBy": "Accepted by {{name}} on {{date}} ({{method}}).",
    "footer": "Amounts in Omani rials (<rial/>). Any change to the items needs a new approval."
  },
  "report": {
    "title": "Visit report",
    "open": "Visit report",
    "back": "Back to the visit",
    "kind": "Visit",
    "date": "Date",
    "window": "Time",
    "arrived": "Arrived",
    "finished": "Finished",
    "team": "Team",
    "lead": "Visit lead",
    "customer": "Customer",
    "location": "Location",
    "contact": "On-site contact",
    "problem": "Problem reported",
    "planned": "Planned visit",
    "work": "Parts and services on this visit",
    "noWork": "No work was recorded on this visit.",
    "item": "Item",
    "done": "Done on this visit",
    "ofTotal": "of {{quantity}}",
    "outcome": "Outcome",
    "findings": "Report",
    "noReport": "No report was written.",
    "photos": "Photos",
    "morePhotos_one": "{{n}} more photo is attached to the visit.",
    "morePhotos_other": "{{n}} more photos are attached to the visit.",
    "acknowledgment": "Customer’s acknowledgment",
    "statement": "The team attended this visit as described above.",
    "notFinished": "This visit is not finished yet: the report is not final.",
    "footer": "A record of the visit, not an invoice.",
    "checks": {
      "title": "Equipment checked",
      "done": "{{n}} done",
      "issues_one": "{{n}} issue",
      "issues_other": "{{n}} issues",
      "noAccess": "{{n}} no access",
      "skipped": "{{n}} skipped",
      "notChecked_one": "{{n}} asset in this visit’s scope was not checked.",
      "notChecked_other": "{{n}} assets in this visit’s scope were not checked.",
      "placeCount_one": "{{n}} asset",
      "placeCount_other": "{{n}} assets",
      "tag": "Tag",
      "type": "Type",
      "position": "Position",
      "outcome": "Outcome",
      "readings": "Readings and checks",
      "note": "Note",
      "reason": "Why:",
      "faultJob": "Fault job"
    }
  }
}
